import React from "react";

function FloorPlanImage({ onClick }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 540 840" style={{cursor:'pointer'}}>
      <path fill="#FDB196" d="M0 0H540V840H0z" onClick={() => onClick('living')}></path>
      <text
        style={{ whiteSpace: "pre" }}
        x="269.088"
        y="437.735"
        fill="#333"
        fontFamily="Arial, sans-serif"
        fontSize="22"
        textAnchor="middle"
        onClick={() => onClick('living')}
      >
        Elders&apos; Living area
      </text>
      <path fill="#FAD2A7" d="M0 0H90V170H0z" onClick={() => onClick('locker')}></path>
      <text
        style={{ whiteSpace: "pre" }}
        fill="#333"
        fontFamily="Arial, sans-serif"
        fontSize="22"
        textAnchor="middle"
        transform="translate(-3.763 13.172)"
        onClick={() => onClick('locker')}
      >
        <tspan x="48.688" y="58.304">
          Locker
        </tspan>
        <tspan x="48.688" dy="1em">
          ​
        </tspan>
        <tspan>Room</tspan>
      </text>
      <path fill="#FBEAC8" d="M90 0H190V170H90z" onClick={() => onClick('staff')}></path>
      <text
        style={{ whiteSpace: "pre" }}
        x="48.688"
        y="58.304"
        fill="#333"
        fontFamily="Arial, sans-serif"
        fontSize="22"
        textAnchor="middle"
        transform="translate(88.69 20.048)"
        onClick={() => onClick('staff')}
      >
        Staff
        <tspan x="48.688" dy="1em">
          ​
        </tspan>
        Room
      </text>
      <path fill="#B1D9CD" d="M190 0H300V170H190z" onClick={() => onClick('store')}></path>
      <text
        style={{ whiteSpace: "pre" }}
        x="48.688"
        y="58.304"
        fill="#333"
        fontFamily="Arial, sans-serif"
        fontSize="22"
        textAnchor="middle"
        transform="translate(195.94 23.81)"
        onClick={() => onClick('store')}
      >
        Store
        <tspan x="48.688" dy="1em">
          ​
        </tspan>
        Room
      </text>
      <path fill="#93C2C6" d="M300 0H540V170H300z" onClick={() => onClick('kitchen')}></path>
      <text
        style={{ whiteSpace: "pre" }}
        x="423.379"
        y="91.523"
        fill="#333"
        fontFamily="Arial, sans-serif"
        fontSize="22"
        textAnchor="middle"
        onClick={() => onClick('kitchen')}
      >
        Kitchen
      </text>
      <path fill="#F8DACD" d="M170 170H300V260H170z" onClick={() => onClick('staircase')}></path>
      <text
        style={{ whiteSpace: "pre" }}
        x="48.688"
        y="58.304"
        fill="#333"
        fontFamily="Arial, sans-serif"
        fontSize="22"
        textAnchor="middle"
        transform="translate(190.295 153.64)"
        onClick={() => onClick('staircase')}
      >
        Staircase
        <tspan x="48.688" dy="1em">
          ​
        </tspan>
        Area
      </text>
      <path fill="#9A8D99" d="M300.028 170H540.028V260H300.028z"  onClick={() => onClick('open')}></path>
      <path fill="#9A8D99" d="M460 259H540V339H460z"  onClick={() => onClick('open')}></path>
      <text
        style={{ whiteSpace: "pre" }}
        x="429.023"
        y="217.588"
        fill="#333"
        fontFamily="Arial, sans-serif"
        fontSize="22"
        textAnchor="middle"
        onClick={() => onClick('open')}
      >
        Open Area
      </text>
      <path fill="#F7BBBC" d="M460 340H540V540H460z" onClick={() => onClick('rest')}></path>
      <text
        style={{ whiteSpace: "pre" }}
        x="48.688"
        y="58.304"
        fill="#333"
        fontFamily="Arial, sans-serif"
        fontSize="22"
        textAnchor="middle"
        transform="translate(451.836 362.497)"
        onClick={() => onClick('rest')}
      >
        Rest
        <tspan x="48.688" dy="1em">
          ​
        </tspan>
        Rooms
        <tspan x="48.688" dy="1em">
          ​
        </tspan>
      </text>
      <path fill="#F8E4DB" d="M0 599.995H160V749.995H0z" onClick={() => onClick('office')}></path>
      <text
        style={{ whiteSpace: "pre" }}
        x="48.688"
        y="58.304"
        fill="#333"
        fontFamily="Arial, sans-serif"
        fontSize="22"
        textAnchor="middle"
        transform="translate(28.478 616.511)"
        onClick={() => onClick('office')}
      >
        Office
        <tspan x="48.688" dy="1em">
          ​
        </tspan>
        Room
      </text>
      <path fill="#D9B8BE" d="M370 600H540V750H370z" onClick={() => onClick('elevation')}></path>
      <text
        style={{ whiteSpace: "pre" }}
        x="48.688"
        y="58.304"
        fill="#333"
        fontFamily="Arial, sans-serif"
        fontSize="22"
        textAnchor="middle"
        transform="translate(408.56 614.63)"
        onClick={() => onClick('elevation')}
      >
        Elevator
        <tspan x="48.688" dy="1em">
          ​
        </tspan>
        Area
      </text>
      <path fill="#9FC4E1" d="M0 750H540V840H0z" onClick={() => onClick('front')}></path>
      <text
        style={{ whiteSpace: "pre" }}
        x="272.851"
        y="800.881"
        fill="#333"
        fontFamily="Arial, sans-serif"
        fontSize="22"
        textAnchor="middle"
        onClick={() => onClick('front')}
      >
        Home Front Area
      </text>
      <path fill="#9FC4E1" d="M0 170H170V260H0z" onClick={() => onClick('nursing')}></path>
      <text
        style={{ whiteSpace: "pre" }}
        x="48.688"
        y="58.304"
        fill="#333"
        fontFamily="Arial, sans-serif"
        fontSize="22"
        textAnchor="middle"
        transform="matrix(1.14116 0 0 1.00428 27.677 150.363)"
        onClick={() => onClick('nursing')}
      >
        Nursing
        <tspan x="48.688" dy="1em">
          ​
        </tspan>
        Bay
      </text>
      <path
        fill="#9A8D99"
        d="M315.301 348.691H555.3009999999999V438.691H315.301z"
        transform="matrix(.875 0 0 1.66667 -115.888 18.849)"
        onClick={() => onClick('reception')}
      ></path>
      <text
        style={{ whiteSpace: "pre" }}
        x="48.688"
        y="58.304"
        fill="#333"
        fontFamily="Arial, sans-serif"
        fontSize="22"
        textAnchor="middle"
        transform="translate(213.847 605.755)"
        onClick={() => onClick('reception')}
      >
        Reception
        <tspan x="48.688" dy="1em">
          ​
        </tspan>
        and
        <tspan x="48.688" dy="1em">
          ​
        </tspan>
        Prayer Hall
      </text>
      <path fill="#FBEAC8" d="M370 540H540V600H370z" onClick={() => onClick('library')}></path>
      <text
        style={{ whiteSpace: "pre" }}
        x="454.971"
        y="578.531"
        fill="#333"
        fontFamily="Arial, sans-serif"
        fontSize="22"
        textAnchor="middle"
        onClick={() => onClick('library')}
      >
        Library
      </text>
      <path fill="#93C2C6" d="M0 540H370V600H0z" onClick={() => onClick('dining')}></path>
      <text
        style={{ whiteSpace: "pre" }}
        x="179.603"
        y="581.887"
        fill="#333"
        fontFamily="Arial, sans-serif"
        fontSize="22"
        textAnchor="middle"
        onClick={() => onClick('dining')}
      >
        Dining Area
      </text>
    </svg>
  );
}

export default FloorPlanImage;
